import { IconAngleDoubleDown } from '@iwoca/icons';
import { IwocaLogo } from '@iwoca/orion';

import styles from './BankLinkPreview.module.css';
import previewBankConsent from './images/preview-bank-consent-page.png';
import previewBankLogin from './images/preview-bank-login.png';
import previewBankSelection from './images/preview-bank-selection-page.png';
import previewIntroPage from './images/preview-intro-page.png';
import previewSummary from './images/preview-summary.png';

export const BankLinkPreview = () => {
  return (
    <>
      <nav className={styles.previewNav}>
        <IwocaLogo className={styles.logo} />
      </nav>
      <section className={styles.bankLinkPreviewContainer}>
        <h1 className={styles.bankLinkPreviewTitle}>
          What your trusted third party will see when they use your secure
          shareable link.
        </h1>
        <img
          src={previewSummary}
          alt="Instructions on shareable link"
          className={styles.screenshot}
        />
        <div className={styles.scrollDown}>
          <IconAngleDoubleDown className={styles.scrollDownIcon} />
          <p className={styles.scrollDownContent}>
            Scroll down for further detail
          </p>
          <IconAngleDoubleDown className={styles.scrollDownIcon} />
        </div>
        <div>
          <hr className={styles.scrollDivider} />
        </div>
        <ol className={styles.screenshotList}>
          <li>
            <h2 className={styles.screenshotTitle}>
              Intro screen with information about iwoca and what the customer is
              being asked to provide and why.
            </h2>
            <p className={styles.screenshotDescription}>
              This ensures that your trusted third party is aware of what’s
              being asked for, making it easier for you to share the link
              without too much additional information. This makes the process
              nice and easy for both you and your trusted third party.
            </p>
            <img
              src={previewIntroPage}
              alt="Intro page of agent journey"
              className={styles.screenshot}
            />
            <hr className={styles.screenshotBorder} />
          </li>
          <li>
            <h2 className={styles.screenshotTitle}>Choose the bank to link</h2>
            <p className={styles.screenshotDescription}>
              They will then to choose the bank for the business account that
              they need to link. If it’s not listed, unfortunately it’s not a
              bank that we currently support for open banking.
            </p>
            <img
              src={previewBankSelection}
              alt="Instructions on bank modal"
              className={styles.screenshot}
            />
            <hr className={styles.screenshotBorder} />
          </li>
          <li>
            <h2 className={styles.screenshotTitle}>
              Summary of the information that will be shared with iwoca
            </h2>
            <p className={styles.screenshotDescription}>
              You have already approved this information to be shared with us.
              But we want to ensure that your trusted third party knows what
              information is being shared too. They don’t need to approve this,
              but it helps to ensure they are clear on what they are doing in
              this process. We’ll show your third party which information you’ve
              authorised us to see.
            </p>
            <img
              src={previewBankConsent}
              alt="Instructions on consent page"
              className={styles.screenshot}
            />
            <hr className={styles.screenshotBorder} />
          </li>
          <li>
            <h2 className={styles.screenshotTitle}>
              Log in via the bank to complete the link.
            </h2>
            <p className={styles.screenshotDescription}>
              Your trusted third party will be sent to the website (or app on
              mobile) of the chosen bank to log in. Once logged in a success
              message will appear.
            </p>
            <p className={styles.screenshotDescription}>
              The account is now linked and you will receive an email
              notification to continue your application. If you still have the
              application open in your browser, you will need to refresh the
              screen for the change to be reflected.
            </p>
            <img
              src={previewBankLogin}
              alt="Instructions on link bank login ui"
              className={styles.screenshot}
            />
          </li>
        </ol>
        <div className={styles.readyContainer}>
          <h2 className={styles.readyTitle}>Ready to share your link?</h2>
          <p className={styles.readyDescription}>
            Close this tab and return to your application. Share your secure
            shareable link with you trusted third party by whatever means you
            wish.
          </p>
        </div>
      </section>
    </>
  );
};
